import { Component, OnInit } from '@angular/core';
import { LogoService } from '../data/logo.service';

@Component({
  selector: 'app-clientslogo',
  templateUrl: './clientslogo.component.html',
  styleUrls: ['./clientslogo.component.css']
})
export class ClientslogoComponent implements OnInit {


  logo: any;

  constructor(private logos: LogoService) { }

  ngOnInit(): void {
    this.getData();
  }

  getData(): void{
    this.logos.getLogoData().subscribe( logo => this.logo = logo );
    console.log(this.logo);
  }
}
